import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useRef } from 'react';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';
import { useIntl } from 'react-intl';
import ItemsFilter from './filters/ItemsFilter';
import NumberFilter from './filters/NumberFilter';
import SearchFilter from './filters/SearchFilter';
import SelectFilter from './filters/SelectFilter';
import UserFilter from './filters/UserFilter';
const ColumnHeader = ({ filter, sortKey, onSort, sortDescFirst, onFilter, searchParams = {}, className, title, id, visible = true, style, badge = undefined, }) => {
    const intl = useIntl();
    const target = useRef(null);
    if (!visible)
        return null;
    const isSearchFiltered = filter && searchParams.search && searchParams.search[filter.key] !== undefined;
    const isSelectFiltered = filter && searchParams.select && searchParams.select[filter.key] !== undefined;
    const isItemsFiltered = filter &&
        searchParams.filter &&
        searchParams.filter[filter.key] &&
        searchParams.filter[filter.key].items &&
        searchParams.filter[filter.key].items.length > 0;
    const isNumberFiltered = filter &&
        searchParams.filter &&
        searchParams.filter[filter.key] &&
        (searchParams.filter[filter.key].lesser != null ||
            searchParams.filter[filter.key].greater != null);
    const sortClassName = classNames('fa margin10R', {
        clickable: sortKey,
        'fa-caret-down': sortKey && searchParams.desc,
        'fa-caret-up': sortKey && !searchParams.desc,
    });
    const getFilter = filterParam => {
        if (filterParam.type === 'search') {
            return (_jsx(SearchFilter, { initialValue: searchParams.search && searchParams.search[filterParam.key], onFilter: filterItems => onFilter(filterItems), isFiltered: isSearchFiltered, intl: intl }));
        }
        if (filterParam.type === 'items') {
            return (_jsx(ItemsFilter, { items: filterParam.items, renderItem: filterParam.renderItem, initialFilteredItems: searchParams.filter &&
                    searchParams.filter[filterParam.key] &&
                    searchParams.filter[filterParam.key].items, onFilter: filterItems => onFilter(filterItems), isFiltered: isItemsFiltered, intl: intl }));
        }
        if (filterParam.type === 'select') {
            return (_jsx(SelectFilter, { initialValue: searchParams.select && searchParams.select[filterParam.key], onFilter: filterItems => onFilter(filterItems), loadFunc: filterParam.loadFunc, isFiltered: isSelectFiltered, intl: intl }));
        }
        if (filterParam.type === 'user') {
            return (_jsx(UserFilter, { initialValue: searchParams.filter &&
                    searchParams.filter[filterParam.key] &&
                    searchParams.filter[filterParam.key].items &&
                    searchParams.filter[filterParam.key].items[0], onFilter: filterItems => onFilter(filterItems), isFiltered: isItemsFiltered, intl: intl }));
        }
        if (filterParam.type === 'number') {
            return (_jsx(NumberFilter, { initialValue: searchParams.filter && searchParams.filter[filterParam.key], onFilter: filterItems => onFilter(filterItems), isFiltered: isNumberFiltered, intl: intl }));
        }
    };
    return (_jsxs("th", Object.assign({ className: classNames(className, 'sticky-header'), id: id, style: style, ref: target }, { children: [_jsxs("span", Object.assign({ className: classNames({ clickable: onSort }), onClick: () => onSort && onSort(sortKey, sortDescFirst) }, { children: [!!sortKey && sortKey === searchParams.sortKey && _jsx("i", { className: sortClassName }), title] })), badge && _jsx("br", {}), badge, filter && (_jsx(OverlayTrigger, Object.assign({ trigger: "click", rootClose: true, placement: "bottom", overlay: _jsx(Popover, Object.assign({ id: "filterPopover" }, { children: getFilter(filter) })), container: () => target.current }, { children: _jsx("i", { className: classNames('fa fa-filter margin10L clickable filter-icon', {
                        red: isItemsFiltered || isSearchFiltered || isSelectFiltered || isNumberFiltered,
                    }) }) })))] })));
};
export default ColumnHeader;
